
import { computed, defineComponent, PropType } from 'vue'
import { InputFileStatusesArray, InputFileStatusesClassesMap, InputFileStatusesEnum } from './BFileInput.types'

export default defineComponent({
  name: 'BFileInput',
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      default: '',
    },
    variant: {
      type: String as PropType<InputFileStatusesEnum>,
      default: InputFileStatusesEnum.DEFAULT,
      validator: (prop: InputFileStatusesEnum) => InputFileStatusesArray.includes(prop),
    },
  },
  setup(props, { emit }) {

    function uploadFile(event: any) {
      emit('uploadFile', event.srcElement.files)
    }

    const classes = computed(() => InputFileStatusesClassesMap[props.variant])

    return {
      uploadFile,
      classes,
    }
  },
})
